import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Contacts Access',
  basePath: '/contacts-access',
  columns: [
    { key: 'contact_name', label: 'Contact', sortable: true },
    { key: 'menu_title', label: 'Menu', sortable: true },
  ],
  fields: [
    { key: 'contacts_id', label: 'Contact', type: 'async-select',
      optionsUrl: '/contacts/options', required: true },
    { key: 'menu_id', label: 'Menu', type: 'async-select',
      optionsUrl: '/menu/options', required: true },
  ],
  defaultSort: { field: 'contact_name', dir: 'asc' },
});
